import React from "react";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton";
import { renderField } from "./_fieldRenderer";
import "./forms.css";

class AnomalyForm extends React.Component {
  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="cause"
                type="text"
                component={renderField}
                label="Causa"
                placeholder="O que causou a anomalia?"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="solution"
                type="text"
                component={renderField}
                label="Solução"
                placeholder="O que foi feito para resolver o problema?"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Salvar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };
}

const validate = (values) => {
  const errors = {};
  if (!values.cause) {
    errors.cause = "Obrigatório";
  }
  if (!values.solution) {
    errors.solution = "Obrigatório";
  }
  return errors;
};

AnomalyForm = reduxForm({ form: "AnomalyForm", validate })(AnomalyForm);
export default AnomalyForm;



// WEBPACK FOOTER //
// ./src/forms/AnomalyForm.jsx